import { Component } from '@angular/core';

@Component({
  selector: 'v2m-blog-v250',
  templateUrl: './blog-v250.component.html',
  styleUrls: ['./blog-v250.component.scss']
})
export class BlogV250Component {

}
